"use strict";

import angular from "angular";

export class DialogCtrl {
    constructor($mdDialog, $sce, locals) {
        this.$mdDialog = $mdDialog;
        this.$sce = $sce;
        this.locals = locals;
        this.loading = angular.copy(this.locals.loading);
        this.bodyTrustedHtml = locals.templateHtml
            ? this.$sce.trustAsHtml(locals.templateHtml)
            : null;
    }

    cancel() {
        if (
            typeof this.locals.onExitDialog === "function" ||
            typeof this.onExitDialog === "function"
        ) {
            return this.locals.onExitDialog();
        }
        this.$mdDialog.cancel();
    }
}

angular
    .module("nucont.shared")
    .controller("DialogCtrl", ["$mdDialog", "$sce", "locals", DialogCtrl]);
